// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ranking_container__z3iEk {
  width: 100%;
  justify-content: center;
}

.Ranking_container__z3iEk .Ranking_header__94nVl {
  justify-content: center;
  align-items: center;
}

.Ranking_container__z3iEk .Ranking_header__94nVl .Ranking_titleContainer__PxwTr {
  animation: Ranking_toright__gOmsl 0.3s;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Ranking_container__z3iEk .Ranking_header__94nVl .Ranking_titleContainer__PxwTr h4 {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.Ranking_filters__I37j1 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Ranking_filterButton__kSbSz {
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.Ranking_filterButton__kSbSz p {
  text-transform: capitalize;
  margin-left: 5px;
  font-weight: 400;
}

/*---Información---*/
.Ranking_container__z3iEk .Ranking_tableContainer__5of50 {
  animation: Ranking_toleft__XdzOI 0.3s;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
  margin-bottom: 30px;
  max-height: 70vh;
}

.Ranking_container__z3iEk .Ranking_loader__KEBjj {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes Ranking_init__NvOzT {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes Ranking_toright__gOmsl {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes Ranking_toleft__XdzOI {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Ranking/Ranking.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sCAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,qCAAsB;EACtB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  width: 100%;\n  justify-content: center;\n}\n\n.container .header {\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: toright 0.3s;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.filterButton {\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.filterButton p {\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n/*---Información---*/\n.container .tableContainer {\n  animation: toleft 0.3s;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n  margin-bottom: 30px;\n  max-height: 70vh;\n}\n\n.container .loader {\n  height: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toright {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toleft {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Ranking_container__z3iEk`,
	"header": `Ranking_header__94nVl`,
	"titleContainer": `Ranking_titleContainer__PxwTr`,
	"toright": `Ranking_toright__gOmsl`,
	"filters": `Ranking_filters__I37j1`,
	"filterButton": `Ranking_filterButton__kSbSz`,
	"tableContainer": `Ranking_tableContainer__5of50`,
	"toleft": `Ranking_toleft__XdzOI`,
	"loader": `Ranking_loader__KEBjj`,
	"init": `Ranking_init__NvOzT`
};
export default ___CSS_LOADER_EXPORT___;
